<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="onFiltered"
    @on-cancel="hide()"
    :okText="$t('ToFilter')"
    :closeText="$t('Close')"
    maxWidth="40%"
  >
    <div v-for="(item, index) in filterItems" :key="item.uuid">
      <v-row>
        <v-col cols="1" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                large
                color="error"
                icon
                @click="removeFilter(item.uuid)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Remove") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="5">
          <v-autocomplete
            v-model="item.fieldTitle"
            v-bind:label="$t('Field')"
            :items="getFieldTitles()"
            :error-messages="fieldTitleErrors(index)"
          ></v-autocomplete>
        </v-col>
        <v-col cols="5">
          <v-autocomplete
            v-model="item.fieldValues"
            :items="getFieldValues(item.fieldTitle)"
            v-bind:label="$t('Value')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col cols="1" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                large
                color="primary"
                icon
                @click="addFilter()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Add") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-subheader v-if="!isLastFilter(item.uuid)">---OR---</v-subheader>
    </div>
  </base-modal>
</template>
<script>
import FilterItem from "@/ecm/models/search/FilterItem";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  name: "FilterModal",
  props: {
    fieldList: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.addFilter();
  },
  data() {
    return {
      modal: {
        title: this.$t("ToFilter"),
        key: "filterModal",
      },
      open: false,
      filterItems: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    filterItems: {
      $each: {
        fieldTitle: { required },
      },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
  },
  methods: {
    getFieldTitles() {
      if (this.fieldList || this.fieldList.length > 0) {
        return Array.from(
          new Set(this.fieldList.filter((f) => f.IsVisible).map((f) => f.Title))
        );
      } else {
        return [];
      }
    },
    getFieldValues(fieldTitle) {
      if (this.fieldList || this.fieldList.length > 0) {
        return Array.from(
          new Set(
            this.fieldList
              .filter((f) => f.Title == fieldTitle && f.IsVisible)
              .map((f) => f.Value)
          )
        );
      } else {
        return [];
      }
    },
    fieldTitleErrors(index) {
      const errors = [];
      if (!this.$v.filterItems.$each[index].fieldTitle.$dirty) return errors;
      !this.$v.filterItems.$each[index].fieldTitle.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    addFilter() {
      this.filterItems.push(new FilterItem());
    },
    removeFilter(uuid) {
      this.filterItems = this.filterItems.filter((item) => item.uuid !== uuid);
      if (this.filterItems.length == 0) {
        this.addFilter();
      }
    },
    onFiltered() {
      if (this.filterItems.length == 1 && this.filterItems[0].fieldTitle == "")
        this.$emit("on-filtered", []);
      else {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.$emit("on-filtered", this.filterItems);
        this.hide();
      }
    },
    show() {
      this.open = true;
      this.$v.$reset();
    },
    hide() {
      this.open = false;
      this.$v.$reset();
    },
    isLastFilter(uuid) {
      if (this.filterItems.length <= 1) return true;
      return this.filterItems[this.filterItems.length - 1].uuid == uuid;
    },
  },
};
</script>
